var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_51520",
    "data-name": "Raggruppa 51520",
    transform: "translate(-1396 -5029)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_3",
    "data-name": "Ellisse 3",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1396 5029)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_34858",
    "data-name": "Tracciato 34858",
    d: "M-388.7-830.377l-1.914,1.926a.606.606,0,0,0-.215.56v14.174a.587.587,0,0,0,.215.56l1.873,1.926v.427h-9.412v-.413l1.938-1.976c.192-.2.192-.26.192-.56v-11.459l-5.386,14.369h-.726l-6.274-14.369v9.629a1.366,1.366,0,0,0,.349,1.106l2.52,3.207v.427H-412.7v-.427l2.518-3.207a1.325,1.325,0,0,0,.327-1.106v-11.136a.974.974,0,0,0-.3-.82l-2.241-2.839v-.427h6.962l5.373,12.393,4.729-12.386h6.635Z",
    transform: "translate(1816.702 5869.804)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.23e1144ca5ab31a41eeeb15fba44bd1c.svg";
export { ForwardRef as ReactComponent };